<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <div
        v-loading="loading"
        class="table-box"
        element-loading-text="文件上传中..."
      >
        <el-upload
          v-if="details.type == 'edit'"
          :action="$multifileHost"
          :before-upload="beforeUpload"
          :data="multiParams"
          :file-list="fileUrlArr"
          :multiple="true"
          :on-error="handleError"
          :on-exceed="handleExceed"
          :on-preview="handlePreview"
          :on-progress="handleProgress"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :show-file-list="false"
          accept=".png,.jpg,.jpeg,.gif,.pdf,.zip,.7z,.rar"
          class="upload-demo"
        >
          <el-button :disabled="details.type == 'look'" type="primary"
            >点击上传
          </el-button>
        </el-upload>
        <el-table :data="tableData" height="350" style="width: 100%">
          <el-table-column
            align="center"
            label="序号"
            type="index"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            label="文件名称"
            prop="fileName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="上传时间"
            prop="createTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="scope">
              <el-button type="text" @click="lookFileClick(scope.row, 1)"
                >查看
              </el-button>
              <el-divider
                v-if="details.type == 'edit'"
                direction="vertical"
              ></el-divider>
              <el-popconfirm
                v-if="details.type == 'edit'"
                title="确定删除该附件吗？"
                @confirm="deleteClick(scope.row, scope.$index)"
              >
                <el-button
                  slot="reference"
                  :disabled="details.type == 'look'"
                  type="text"
                  >删除
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
      <CoursePersonnel
        :details="coursePersonnelDetails"
        @closeDialog="closeDialog"
      ></CoursePersonnel>
    </el-dialog>
    <FileModal
      :details="fileModalDetails"
      @handleClose="userModalClose"
    ></FileModal>
    <el-image
      ref="imgViewRef"
      :height="100"
      :preview-src-list="fileUrlList"
      :preview-teleported="true"
      :src="$previewImg + fileUrl"
      :width="100"
      style="display: none"
    >
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline" style="font-size: 28px"></i>
      </div>
    </el-image>
  </div>
</template>
<script>
import { deleteFile, getFilesByDetailid } from "@/api/home/index";
import CoursePersonnel from "./coursePersonnel.vue";
import FileModal from "@/views/user/components/xypj/fileModal.vue";
import Cookies from "js-cookie";

export default {
  components: { FileModal, CoursePersonnel },
  props: ["details"],
  data() {
    return {
      tableData: [],
      fileType: 1,
      dialogVisible: false,
      userModalDetails: {},
      coursePersonnelDetails: {
        dialogVisible: false,
      },
      multiParams: {
        detailId: "",
        fileType: 1,
      },
      fileUrlArr: [],
      fileModalDetails: {
        dialogVisible: false,
        title: "查看附件",
        data: {},
      },
      fileUrlList: [],
      fileUrl: "",
      loading: false,
    };
  },
  watch: {
    details: {
      handler(newValue, oldValue) {
        // 这里不仅可以监听到对象引用的变化，还能监听到对象内部属性的变化
        this.dialogVisible = newValue.dialogVisible;
        this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
        console.log("newValue.data", newValue.data);
        this.userModalDetails = newValue.data;
        if (newValue.data.fileType == 1) {
          this.tableData = newValue.data.mutilpartFiles || [];
        } else {
          this.tableData = newValue.data.mutilpartBcFiles || [];
        }
        this.tableData = this.deduplicationArr(this.tableData);
        if (newValue.dialogVisible) {
          this.getById();
        }
      },
      deep: true, // 开启深度监听
    },
  },
  mounted() {},
  methods: {
    deduplicationArr(arr) {
      let seenTimestamps = new Set();
      let uniqueArr = arr.filter((item) => {
        if (item.id !== null) {
          // 如果 id 不为空，则直接保留该元素
          return true;
        } else {
          // 如果 id 为空，则检查 timestamp 是否已经存在
          if (!seenTimestamps.has(item.timestamp)) {
            seenTimestamps.add(item.timestamp);
            return true;
          } else {
            return false;
          }
        }
      });
      return uniqueArr;
    },
    // 上传文件之前的钩子
    beforeUpload(file) {
      console.log("beforeUpload", file);
      const { uid, name, size } = file;
      this.multiParams.detailId = this.userModalDetails.id;
      this.multiParams.fileType = this.fileType;
      console.log(uid, name, size);
      const fileTypeFlag =
        /^.png|.jpg|.jpeg|.gif|.pdf|.zip|.7z|.rar|.gz|.tar$/.test(
          name.substring(name.lastIndexOf(".")).toLowerCase(),
        );
      if (!fileTypeFlag) {
        this.$message({
          message:
            "文件类型只能是.png|.jpg|.jpeg|.gif|.pdf|.zip|.7z|.rar|.gz|.tar",
          type: "warning",
          duration: "5000",
        });
        this.fileUrlArr = [];
        return false;
      }
      // 文件大小限制
      if (size > 1024 * 1024 * 100) {
        this.$message.warning("文件大小不能超过100Mb");
        return false;
      }
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.fileUrlArr = "";
      console.log("handleRemove", file, fileList);
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    // 文件上传时的钩子
    handleProgress(event, file, fileList) {
      console.log(event, file, fileList);
      this.loading = true;
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file) {
      console.log("response", response);
      console.log("file", file);
      if (response.code == 200) {
        response.result[0].timestamp = this.$moment().valueOf();
        this.tableData.push(response.result[0]);
        this.loading = false;

        // this.getById();
      } else {
        this.$message.error(response.message);
        this.fileUrlArr = [];
      }
    },
    handleError(scope, err, file, fileList) {},
    handlePreview(row, type) {
      // type:1对应资料,2:补充资料
      this.lookFileClick(row, type);
    },
    lookFileClick(group, type) {
      // type:1对应资料,2:补充资料
      // 查看附件
      let fileName =
        type == 1
          ? group.fileName
          : type == 2
            ? group.complementFileName
            : group.fileName;
      let fileUrl =
        type == 1
          ? group.fileUrl
          : type == 2
            ? group.complementFile
            : group.fileUrl;

      const extension = fileName.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
      const pdfExtension = "pdf";
      const zipExtensions = ["zip", "rar", "7z", "gz", "tar"];
      let token = this.$Cookies.get("xh_userInfo")
        ? JSON.parse(this.$Cookies.get("xh_userInfo")).token
        : "";
      console.log(token, "tokennnn");
      if (imageExtensions.includes(extension)) {
        // img
        this.fileUrl = this.$previewImg + fileUrl + `?token=${token}`;
        let fileUrlList = [];
        fileUrlList.push(this.$previewImg + fileUrl + `?token=${token}`);
        this.fileUrlList = fileUrlList;
        this.$refs.imgViewRef.showViewer = true; // 打开预览
      } else if (extension === pdfExtension) {
        // pdf
        this.fileModalDetails.dialogVisible = true;
        group.token = token;
        console.log("group", group);
        this.fileModalDetails.data = group;
      } else if (zipExtensions.includes(extension)) {
        // 压缩包
        window.location.href = `${this.$previewImg + fileUrl + `?token=${token}`}`;
      }
    },
    handleClose() {
      console.log("details", this.details);
      if (this.tableData.length > 0) {
        this.tableData.forEach((item, index) => {
          if (!item.id) {
            if (this.fileType == 1)
              this.details.data.mutilpartFiles.push({
                ...item,
                attachNum: this.tableData.length,
                fileType: this.fileType,
              });
            if (this.fileType == 2)
              this.details.data.mutilpartBcFiles.push({
                ...item,
                complementNum: this.tableData.length,
                fileType: this.fileType,
              });
          }
        });
        if (this.fileType == 1) {
          this.details.data.mutilpartFiles = this.deduplicationArr(
            this.details.data.mutilpartFiles,
          );
        }
        if (this.fileType == 2) {
          this.details.data.mutilpartBcFiles = this.deduplicationArr(
            this.details.data.mutilpartBcFiles,
          );
        }
      }
      this.details.data.fileType = this.fileType;
      if (this.fileType == 1)
        this.details.data.attachNum = this.tableData.length;
      if (this.fileType == 2)
        this.details.data.complementNum = this.tableData.length;
      this.$emit("handleClose");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.pageNo = 1;
      this.params.pageSize = val;
      this.getById();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val;
      this.getById();
    },
    getById() {
      if (!this.userModalDetails.declareDetailId) {
        return false;
      }
      getFilesByDetailid({
        ...this.params,
        detailId: this.userModalDetails.declareDetailId,
        fileType: this.fileType,
      }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.result || [];
          if (
            this.details.data &&
            this.details.data.mutilpartFiles &&
            this.details.data.mutilpartFiles.length > 0 &&
            this.fileType == 1
          ) {
            this.tableData = [
              ...this.tableData,
              ...this.details.data.mutilpartFiles,
            ];
            console.log("this.tableData", this.tableData);
            this.tableData = this.deduplicationArr(this.tableData);
          }
          if (
            this.details.data &&
            this.details.data.mutilpartBcFiles &&
            this.details.data.mutilpartBcFiles.length > 0 &&
            this.fileType == 2
          ) {
            this.tableData = [
              ...this.tableData,
              ...this.details.data.mutilpartBcFiles,
            ];
            console.log("this.tableData", this.tableData);
            this.tableData = this.deduplicationArr(this.tableData);
          }
          this.total = res.result.total;
        }
      });
    },
    deleteClick(row, index) {
      console.log("row", row);
      if (row.id) {
        deleteFile({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.tableData.splice(index, 1);
            // this.getById();
          }
        });
      } else if (this.fileType == 1) {
        this.tableData.splice(index, 1);
        this.userModalDetails.mutilpartFiles.forEach((item, i) => {
          if (item.timestamp == row.timestamp)
            this.details.data.mutilpartFiles.splice(i, 1);
        });
      } else {
        this.tableData.splice(index, 1);
        this.userModalDetails.mutilpartBcFiles.forEach((item, i) => {
          if (item.timestamp == row.timestamp)
            this.details.data.mutilpartBcFiles.splice(i, 1);
        });
      }
    },
    closeDialog() {
      this.coursePersonnelDetails.dialogVisible = false;
    },
    // 查看附件弹窗
    userModalClose() {
      this.fileModalDetails.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  .page-box {
    text-align: right;
  }
}
</style>
